import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
export const getPaymentsEligibility = basicSelector(state => state.paymentsEligibility);